import { AntError } from '@antony/ng-ui';

export class AppError extends AntError {
  constructor(
    key: string,
    message: string,
    readonly actionName?: string
  ) {
    super(key, message);
  }
}
